import React from 'react';
import styled from 'styled-components';
import {
  wMedium, wLight, maxWidth, retina,
} from 'Utils/utilsStyle';

const StyledWrapper = styled.div<{ bgColor?: string, type?: string, margin?: string }>`
  background-color: ${(props) => (props.bgColor ? props.bgColor : '#001760')};
  border-radius: 8px;
  height: ${(props) => (props.type === 'stats' ? '118px' : '103px')};
  width: ${(props) => (props.type === 'stats' ? '185px' : '170px')};
  padding: 10px;
  margin: ${(props) => props.margin};
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 6px;
    height: ${(props) => (props.type === 'stats' ? '100px' : '80px')};
    width: ${(props) => (props.type === 'stats' ? '140px' : '120px')};
    padding: 7px;
  }
  .topLeftText{
    color: #FFFFFF;
    font-family:'Roboto Slab';
    font-weight: ${wLight};
    font-size: ${(props) => (props.type === 'stats' ? '14.8px' : '9px')};
    line-height: ${(props) => (props.type === 'stats' ? '14.8px' : '12px')};
    display: block;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: ${(props) => (props.type === 'stats' ? '12px' : '7px')};
      line-height: ${(props) => (props.type === 'stats' ? '13px' : '9px')};
    }
  }
  .centerText{
    color: #FFFFFF;
    font-family:'Roboto';
    font-size: ${(props) => (props.type === 'stats' ? '36px' : '18px')};
    line-height: ${(props) => (props.type === 'stats' ? '30px' : '20px')};;
    font-weight: ${wMedium};
    display: flex;
    justify-content: space-around;
    text-align: center;
    margin-top:13px;
    min-height: 36px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: ${(props) => (props.type === 'stats' ? '26px' : '13px')};
      line-height: ${(props) => (props.type === 'stats' ? '27px' : '13px')};;
      max-height: 26px;
      overflow: hidden;
      min-height: auto;
    }
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .bottomText{
    color: #fff;
    font-weight: ${wLight};
    font-size: ${(props) => (props.type === 'stats' ? '12.33px' : '10px')};
    font-family:'Roboto';
    display: flex;
    justify-content: space-around;
    margin-top: 11px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: ${(props) => (props.type === 'stats' ? '10px' : '8px')};
      margin-top: 8px;
    }
  }
`;
type Props = {
  topLeftText?: string,
  company?: string | number,
  percentage?: string,
  engagements?: number | string,
  bgColor?: string,
  type?: string,
  margin?: string,
};
const defaultProps = {
  topLeftText: 'Entity',
  company: 'Company Name',
  percentage: '',
  engagements: '',
  bgColor: '',
  type: '',
  margin: '',
};

const EntityTile = function EntityTile(props: Props) {
  const {
    topLeftText,
    company,
    engagements,
    bgColor,
    type,
    margin,
    percentage,
  } = props;

  return (
    <StyledWrapper bgColor={bgColor} type={type} className="data-entity" margin={margin}>
      <span className="topLeftText">{topLeftText}</span>
      <span className="centerText text-truncate-one-line">{company?.toLocaleString()}</span>
      <span className="bottomText">
        {percentage !== '' && `${percentage || ''} `}
        {engagements}
        {type !== 'stats' && ' mentions'}
      </span>
    </StyledWrapper>
  );
};

EntityTile.defaultProps = defaultProps;
export default EntityTile;
